module.exports = __webpack_public_path__ + "static/media/c17.a473cd97.png";